import {gql} from 'graphql-request';

export const GET_WINDOW_TYPES_DATA = gql`
	query {
		windowTypes {
			id
			name
			slug
		}
	}
`;

export const GET_WINDOW_DIMENSIONS_BY_TYPE = gql`
	query GetWindowDimensions($windowTypeSlug: String!) {
		windowDimensions(windowTypeSlug: $windowTypeSlug) {
			dimensions {
				height
				width
				slug
				isEmergencyExit
			}
			id
			name
			shortName
			slug
		}
	}
`;

export const GET_BALCONY_DOOR_TYPES_DATA = gql`
	query {
		balconyDoorTypes {
			id
			name
			slug
		}
	}
`;

export const GET_BALCONY_DOOR_DIMENSIONS_BY_TYPE = gql`
	query GetBalconyDoorDimensions($balconyDoorTypeSlug: String!) {
		balconyDoorDimensions(balconyDoorTypeSlug: $balconyDoorTypeSlug) {
			dimensions {
				height
				width
				slug
			}
			id
			name
			shortName
			slug
		}
	}
`;

export const GET_WINDOW_BY_TYPE = gql`
	query GetWindow($windowTypeSlug: String!, $dimensionSlug: String!) {
		window(windowTypeSlug: $windowTypeSlug, dimensionSlug: $dimensionSlug) {
			id
			name
		}
	}
`;

export const GET_OPTIONS_DATA = gql`
	query {
		options {
			defaults {
				materials
				uValues
			}
			materials {
				id
			}
			uValues {
				id
			}
		}
	}
`;

export const GET_WINDOW_AND_OPTIONS_DATA = gql`
	query GetWindowAndOptions($windowTypeSlug: String!, $dimensionSlug: String!) {
		window(windowTypeSlug: $windowTypeSlug, dimensionSlug: $dimensionSlug) {
			name
			id
			options {
				defaults {
					materials
					uValues
					colors
					windowBars
					glassTypes
					glassLayers
					windowHandles
					windowVents
				}
				materials {
					id
					disabled
				}
				windowVents {
					id
					disabled
				}
				uValues {
					id
					disabled
				}
				glassLayers {
					id
					childIDs
					disabled
				}
				colors {
					id
					disabled
				}
				windowBars {
					id
					disabled
				}
				glassTypes {
					id
					disabled
				}
				windowHandles {
					id
					disabled
				}
			}
		}
	}
`;

export const GET_BALCONY_DOOR_AND_OPTIONS_DATA = gql`
	query GetBalconyDoorAndOptions($balconyDoorTypeSlug: String!, $dimensionSlug: String!) {
		balconyDoor(balconyDoorTypeSlug: $balconyDoorTypeSlug, dimensionSlug: $dimensionSlug) {
			name
			id
			options {
				defaults {
					materials
					uValues
					colors
					bars
					glassTypes
					glassLayers
					handles
					parapetHeights
				}
				materials {
					id
					disabled
				}
				uValues {
					id
					disabled
				}
				glassLayers {
					id
					childIDs
					disabled
				}
				colors {
					id
					disabled
				}
				bars {
					id
					disabled
				}
				glassTypes {
					id
					disabled
				}
				handles {
					id
					disabled
				}
				parapetHeights {
					id
					disabled
					imageAsset {
						_type
						altText
						asset {
							_ref
							_type
						}
					}
				}
			}
		}
	}
`;

export const CHECK_CONFIGURATION_QUERY = gql`
	query CheckConfiguration(
		$count: Int!
		$windowTypeSlug: String!
		$dimensionSlug: String!
		$materialId: String!
		$uValueId: String!
		$colorId: String!
		$windowBarId: String!
		$glassLayerId: String!
		$windowVentId: String!
		$glassTypeIds: [String!]!
		$windowHandleId: String!
	) {
		checkConfiguration(
			count: $count
			windowTypeSlug: $windowTypeSlug
			dimensionSlug: $dimensionSlug
			materialId: $materialId
			uValueId: $uValueId
			colorId: $colorId
			windowBarId: $windowBarId
			glassLayerId: $glassLayerId
			glassTypeIds: $glassTypeIds
			windowHandleId: $windowHandleId
			windowVentId: $windowVentId
		) {
			isValidConfiguration
			suppliers {
				id
				name
				price
				errors
				comparableProperties {
					name
					value
				}
			}
		}
	}
`;

export const CHECK_BALCONY_DOOR_CONFIGURATION_QUERY = gql`
	query CheckBalconyDoorConfiguration(
		$count: Int!
		$balconyDoorTypeSlug: String!
		$dimensionSlug: String!
		$materialId: String!
		$uValueId: String!
		$colorId: String!
		$barId: String!
		$glassLayerId: String!
		$glassTypeIds: [String!]!
		$handleId: String!
		$parapetHeight: Int!
	) {
		checkBalconyDoorConfiguration(
			count: $count
			balconyDoorTypeSlug: $balconyDoorTypeSlug
			dimensionSlug: $dimensionSlug
			materialId: $materialId
			uValueId: $uValueId
			colorId: $colorId
			barId: $barId
			glassLayerId: $glassLayerId
			glassTypeIds: $glassTypeIds
			handleId: $handleId
			parapetHeight: $parapetHeight
		) {
			isValidConfiguration
			suppliers {
				id
				name
				price
				errors
				comparableProperties {
					name
					value
				}
			}
		}
	}
`;

export const CHECK_SHIPPING_PRICE_QUERY = gql`
	query CheckShippingPrice($postalCode: String!) {
		checkShippingPrice(postalCode: $postalCode)
	}
`;

export const GET_CART_ITEMS_QUANTITY = gql`
	query Cart($cartUID: String!) {
		cart(cartUID: $cartUID) {
			cartUID
			totalItems
			windows {
				cartItemNumber
			}
			balconyDoors {
				cartItemNumber
			}
		}
	}
`;

export const CREATE_AND_ADD_TO_CART = gql`
	mutation CreateAndAddToCart(
		$count: Int!
		$windowTypeSlug: String!
		$dimensionSlug: String!
		$materialId: String!
		$uValueId: String!
		$colorId: String!
		$windowBarId: String!
		$glassLayerId: String!
		$windowVentId: String!
		$glassTypeIds: [String!]!
		$windowHandleId: String!
	) {
		createAndAddToCart(
			count: $count
			windowTypeSlug: $windowTypeSlug
			dimensionSlug: $dimensionSlug
			materialId: $materialId
			uValueId: $uValueId
			colorId: $colorId
			windowBarId: $windowBarId
			glassLayerId: $glassLayerId
			glassTypeIds: $glassTypeIds
			windowHandleId: $windowHandleId
			windowVentId: $windowVentId
		) {
			cartUID
			cartItemNumber
		}
	}
`;

export const ADD_TO_CART = gql`
	mutation AddToCart(
		$cartUID: String!
		$count: Int!
		$windowTypeSlug: String!
		$dimensionSlug: String!
		$materialId: String!
		$uValueId: String!
		$colorId: String!
		$windowBarId: String!
		$glassLayerId: String!
		$windowVentId: String!
		$glassTypeIds: [String!]!
		$windowHandleId: String!
	) {
		addToCart(
			cartUID: $cartUID
			count: $count
			windowTypeSlug: $windowTypeSlug
			dimensionSlug: $dimensionSlug
			materialId: $materialId
			uValueId: $uValueId
			colorId: $colorId
			windowBarId: $windowBarId
			glassLayerId: $glassLayerId
			glassTypeIds: $glassTypeIds
			windowHandleId: $windowHandleId
			windowVentId: $windowVentId
		)
	}
`;

export const MODIFY_CART_ITEM = gql`
	mutation ModifyCartItem(
		$cartUID: String!
		$cartItemNumber: Int!
		$windowTypeSlug: String!
		$dimensionSlug: String!
		$materialId: String!
		$uValueId: String!
		$colorId: String!
		$windowBarId: String!
		$glassLayerId: String!
		$windowVentId: String!
		$glassTypeIds: [String!]!
		$windowHandleId: String!
	) {
		modifyCartItemData(
			cartUID: $cartUID
			cartItemNumber: $cartItemNumber
			windowTypeSlug: $windowTypeSlug
			dimensionSlug: $dimensionSlug
			materialId: $materialId
			uValueId: $uValueId
			colorId: $colorId
			windowBarId: $windowBarId
			glassLayerId: $glassLayerId
			glassTypeIds: $glassTypeIds
			windowHandleId: $windowHandleId
			windowVentId: $windowVentId
		)
	}
`;

export const CREATE_AND_ADD_TO_BALCONY_DOOR_CART = gql`
	mutation CreateAndAddToBalconyDoorCart(
		$count: Int!
		$balconyDoorTypeSlug: String!
		$dimensionSlug: String!
		$materialId: String!
		$uValueId: String!
		$colorId: String!
		$barId: String!
		$glassLayerId: String!
		$glassTypeIds: [String!]!
		$handleId: String!
		$parapetHeight: Int!
	) {
		createAndAddToBalconyDoorCart(
			count: $count
			balconyDoorTypeSlug: $balconyDoorTypeSlug
			dimensionSlug: $dimensionSlug
			materialId: $materialId
			uValueId: $uValueId
			colorId: $colorId
			barId: $barId
			glassLayerId: $glassLayerId
			glassTypeIds: $glassTypeIds
			handleId: $handleId
			parapetHeight: $parapetHeight
		) {
			cartUID
			cartItemNumber
		}
	}
`;

export const ADD_TO_BALCONY_DOOR_CART = gql`
	mutation AddToBalconyDoorCart(
		$cartUID: String!
		$count: Int!
		$balconyDoorTypeSlug: String!
		$dimensionSlug: String!
		$materialId: String!
		$uValueId: String!
		$colorId: String!
		$barId: String!
		$glassLayerId: String!
		$glassTypeIds: [String!]!
		$handleId: String!
		$parapetHeight: Int!
	) {
		addToBalconyDoorCart(
			cartUID: $cartUID
			count: $count
			balconyDoorTypeSlug: $balconyDoorTypeSlug
			dimensionSlug: $dimensionSlug
			materialId: $materialId
			uValueId: $uValueId
			colorId: $colorId
			barId: $barId
			glassLayerId: $glassLayerId
			glassTypeIds: $glassTypeIds
			handleId: $handleId
			parapetHeight: $parapetHeight
		)
	}
`;

export const MODIFY_BALCONY_DOOR_CART_ITEM = gql`
	mutation ModifyBalconyDoorCartItemData(
		$cartUID: String!
		$cartItemNumber: Int!
		$balconyDoorTypeSlug: String!
		$dimensionSlug: String!
		$materialId: String!
		$uValueId: String!
		$colorId: String!
		$barId: String!
		$glassLayerId: String!
		$glassTypeIds: [String!]!
		$handleId: String!
		$parapetHeight: Int!
	) {
		modifyBalconyDoorCartItemData(
			cartUID: $cartUID
			cartItemNumber: $cartItemNumber
			balconyDoorTypeSlug: $balconyDoorTypeSlug
			dimensionSlug: $dimensionSlug
			materialId: $materialId
			uValueId: $uValueId
			colorId: $colorId
			barId: $barId
			glassLayerId: $glassLayerId
			glassTypeIds: $glassTypeIds
			handleId: $handleId
			parapetHeight: $parapetHeight
		)
	}
`;

export const MODIFY_CART_ITEM_COUNT = gql`
	mutation ModifyCartItemCount(
		$cartUID: String!
		$cartItemNumber: Int!
		$count: Int!
		$isBalconyDoor: Boolean!
	) {
		modifyCartItemCount(
			cartUID: $cartUID
			cartItemNumber: $cartItemNumber
			count: $count
			isBalconyDoor: $isBalconyDoor
		)
	}
`;

export const REMOVE_CART_ITEM_COUNT = gql`
	mutation RemoveCartItem($cartUID: String!, $cartItemNumber: Int!, $isBalconyDoor: Boolean!) {
		removeCartItem(
			cartUID: $cartUID
			cartItemNumber: $cartItemNumber
			isBalconyDoor: $isBalconyDoor
		)
	}
`;

export const CLEAR_CART = gql`
	mutation ClearCart($cartUID: String!) {
		clearCart(cartUID: $cartUID)
	}
`;

export const GET_CART_ITEMS = gql`
	query Cart($cartUID: String!) {
		cart(cartUID: $cartUID) {
			cartUID
			windows {
				cartItemNumber
				count
				imageAsset {
					_type
					altText
					asset {
						_ref
						_type
					}
				}
				windowType {
					id
					name
					slug
				}
				dimension {
					height
					width
					slug
				}
				material {
					id
					value
				}
				uValue {
					id
					value
				}
				color {
					id
					value
				}
				glassLayer {
					id
					value
				}
				windowBar {
					id
					value
				}
				glassTypes {
					id
					value
				}
				windowHandle {
					id
					value
				}
				windowVent {
					id
					value
				}
				supplierPrices {
					price
					supplier {
						id
						name
						comparableProperties {
							name
							value
						}
					}
				}
			}
			balconyDoors {
				cartItemNumber
				count
				imageAsset {
					_type
					altText
					asset {
						_ref
						_type
					}
				}
				balconyDoorType {
					id
					name
					slug
				}
				dimension {
					height
					width
					slug
				}
				material {
					id
					value
				}
				uValue {
					id
					value
				}
				color {
					id
					value
				}
				glassLayer {
					id
					value
				}
				bar {
					id
					value
				}
				glassTypes {
					id
					value
				}
				handle {
					id
					value
				}
				parapetHeight {
					id
					value
				}
				supplierPrices {
					price
					supplier {
						id
						name
						comparableProperties {
							name
							value
						}
					}
				}
			}
			totalSupplierPrices {
				supplier {
					id
					name
					comparableProperties {
						name
						value
					}
				}
				price
			}
		}
	}
`;

export const GET_EXTENDED_SUPPLIER_DATA = gql`
	query GetExtendedSupplierData(
		$cartUID: String!
		$supplierID: String!
		$simulateNOBBError: Boolean!
	) {
		extendedSupplierData(
			cartUID: $cartUID
			supplierID: $supplierID
			simulateNOBBError: $simulateNOBBError
		) {
			comparableProperties {
				name
				value
			}
			windows {
				cartItemNumber
				count
				priceBreakdown {
					name
					price
					type
				}
				windowType {
					id
					name
					slug
				}
				nobbName
				nobbNumber
				dimension {
					width
					height
					slug
				}
				material {
					id
					value
				}
				uValue {
					id
					value
				}
				color {
					id
					value
				}
				glassLayer {
					id
					value
				}
				windowBar {
					id
					value
				}
				glassTypes {
					id
					value
				}
				windowHandle {
					id
					value
				}
				windowVent {
					id
					value
				}
				price
				etimProperties {
					name
					value
				}
				documents {
					name
					url
				}
				imageAssets {
					_type
					altText
					asset {
						_ref
						_type
					}
				}
				nobbError
			}
			balconyDoors {
				cartItemNumber
				count
				priceBreakdown {
					name
					price
					type
				}
				balconyDoorType {
					id
					name
					slug
				}
				nobbName
				nobbNumber
				dimension {
					width
					height
					slug
				}
				material {
					id
					value
				}
				uValue {
					id
					value
				}
				color {
					id
					value
				}
				glassLayer {
					id
					value
				}
				bar {
					id
					value
				}
				glassTypes {
					id
					value
				}
				handle {
					id
					value
				}
				parapetHeight {
					id
					value
				}
				price
				etimProperties {
					name
					value
				}
				documents {
					name
					url
				}
				imageAssets {
					_type
					altText
					asset {
						_ref
						_type
					}
				}
				nobbError
			}
		}
	}
`;

export const GET_PAYMENT_OPTIONS = gql`
	query PaymentMethodsForCart($cartUID: String!, $selectedSupplierID: String!) {
		paymentMethodsForCart(cartUID: $cartUID, selectedSupplierID: $selectedSupplierID) {
			id
			type
			info
			customerType
			legalInfoLinks {
				url
				endUserDescription
				appendPriceLast
			}
			minLimit
			maxLimit
		}
	}
`;

export const INITIATE_RESURS_BANK_PAYMENT = gql`
	mutation InitiateResursBankPayment(
		$cartUID: String!
		$selectedSupplierID: String!
		$phoneNumber: String!
		$email: String!
		$firstName: String!
		$lastName: String!
		$streetName: String!
		$postalCode: String!
		$city: String!
		$method: ResursbankMethod!
		$successURL: String!
		$signingURL: String!
		$failedURL: String!
		$fnr: String!
		$cardNumber: String!
		$requestedCredit: Int!
		$orderMessage: String!
	) {
		initiateResursBankPayment(
			cartUID: $cartUID
			selectedSupplierID: $selectedSupplierID
			phoneNumber: $phoneNumber
			email: $email
			firstName: $firstName
			lastName: $lastName
			streetName: $streetName
			postalCode: $postalCode
			city: $city
			method: $method
			successURL: $successURL
			signingURL: $signingURL
			failedURL: $failedURL
			fnr: $fnr
			cardNumber: $cardNumber
			requestedCredit: $requestedCredit
			orderMessage: $orderMessage
		) {
			orderID
			orderURL
			status
		}
	}
`;

export const HANDLE_SIGNED_RESURS_BANK_PAYMENT = gql`
	mutation HandleSignedResursBankPayment($token: String!) {
		handleSignedResursBankPayment(token: $token) {
			status
		}
	}
`;

export const GET_RECEIPT = gql`
	query Receipt($cartUID: String!) {
		receipt(cartUID: $cartUID) {
			orderID
			customerData {
				firstName
				lastName
				email
				phoneNumber
				streetName
				postalCode
				city
			}
			supplierData {
				id
				deliveryTime
				name
				description
			}
			orderMessage
			products {
				type
				name
				description
				options {
					name
					price
				}
				pricePer
				quantity
				totalPrice
				dimensionSlug
				windowTypeSlug
			}
			totalShippingPrice
			totalVAT
			totalPrice
			paymentProvider
		}
	}
`;
